import { ImpactReview, PortfolioCoverage, ScoreOverview } from './types';

export const getImpactOverview = (portfolioCoverage?: PortfolioCoverage) => {
  if (
    !portfolioCoverage?.impactSummaryDistribution ||
    !portfolioCoverage?.impactSummaryOverallMonetisation
  )
    return null;

  const {
    impactSummaryDistribution: { downstream, upstream, companySites },
    impactSummaryOverallMonetisation: { totalNetExternality, absoluteNetExternality },
  } = portfolioCoverage;

  return {
    impactDistribution: {
      scoreDownstreamFactor: downstream,
      scoreCompanyFactor: companySites,
      scoreSupplyChainFactor: upstream,
    },
    overallMonetization: {
      externalCostsMillionsEur: absoluteNetExternality,
      externalCostsDividedByRevenue: totalNetExternality,
    },
  };
};

export const getScoreOverview = (scoreOverview?: ScoreOverview) => {
  if (!scoreOverview) return null;

  const { eCost, eScore, sCost, sScore, gCost, gScore, esgCost, esgScore } = scoreOverview;

  return [
    {
      title: 'Environment',
      score: eScore,
      extCostsToRevenue: eCost,
    },
    {
      title: 'Social',
      score: sScore,
      extCostsToRevenue: sCost,
    },
    {
      title: 'Governance',
      score: gScore,
      extCostsToRevenue: gCost,
    },
    {
      title: 'Total',
      score: esgScore,
      extCostsToRevenue: esgCost,
    },
  ];
};

export const getSummary = (impactReview?: ImpactReview) => {
  if (!impactReview?.history || !impactReview?.impactReviewScore) return null;

  const { history, impactReviewScore } = impactReview;

  return {
    companyType: 'BANK',
    score: impactReviewScore.esgScore,
    history: {
      labels: history.map((item) => item.updateDate),
      data: history.map((item) => item.esgScore),
    },
    levels: {
      level: 'L2',
      title: 'ESG impact review',
    },
    generalInformation: {
      stability: 'Moderate',
      dataPrecision: 'Good',
    },
    documents: [
      {
        title: 'Methodology',
        name: 'ESG Impact Review Methodology.pdf',
        path: '/esg/api/file-download/032fc715-0e6a-4c1a-b835-5dc58771b3b8/',
        publicationDate: '2020-06-11',
      },
      {
        title: 'How we are different',
        name: 'Scope ESG Impact Review - How we are different.pdf',
        path: '/esg/api/file-download/5611e0ee-1bd9-43e9-b522-d2e8f348d39f/',
        publicationDate: '2020-07-08',
      },
      {
        title: '2021 ESG report',
        name: '2021 ESG report.pdf',
        path: '/esg/api/generate-report/B5E06464-CF10-476E-B6A8-F30A66C37CE8?year=2021&latestUpdate=2022-12-06',
        publicationDate: '2023-03-29',
      },
    ],
  };
};
